import { Info } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * A small info icon that reveals a short hint on hover or keyboard focus.
 * CSS-only (no tooltip dependency) — the hint is a positioned popover shown via
 * group-hover/focus-within. Anchored below-left so it doesn't clip in narrow
 * columns. Use for brief field explanations (e.g. a stat label).
 */
export function InfoHint({ text, className }: { text: string; className?: string }) {
  return (
    <span className={cn('group/hint relative inline-flex align-middle', className)}>
      <button
        type="button"
        aria-label={text}
        className="text-muted-foreground/60 hover:text-foreground focus-visible:text-foreground inline-flex cursor-help rounded-full outline-none"
      >
        <Info className="size-3.5" />
      </button>
      <span
        role="tooltip"
        className="bg-popover text-popover-foreground pointer-events-none absolute top-full left-0 z-50 mt-1.5 w-56 rounded-md border px-2.5 py-1.5 text-xs leading-snug font-normal normal-case opacity-0 shadow-md transition-opacity duration-150 group-hover/hint:opacity-100 group-focus-within/hint:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
